import { render, staticRenderFns } from "./AgentReceivePayments.vue?vue&type=template&id=bcb2b0e2&scoped=true&"
import script from "./AgentReceivePayments.vue?vue&type=script&lang=js&"
export * from "./AgentReceivePayments.vue?vue&type=script&lang=js&"
import style0 from "./AgentReceivePayments.vue?vue&type=style&index=0&id=bcb2b0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb2b0e2",
  null
  
)

export default component.exports